import { fetchAPI, API_BASE_URL } from "./apiCore";
import { getToken, getuserId } from "./auth";

// Fetch all studies
export const fetchStudies = async () => {
  try {
    return await fetchAPI("biobank/studies", "GET");
  } catch (error) {
    console.error("Error fetching studies:", error);
    return [];
  }
};


// Fetch study by ID
export const fetchStudyById = async (studyId) => {
  try {
    return await fetchAPI(
      `biobank/studies/${encodeURIComponent(studyId)}`,
      "GET"
    );
  } catch (error) {
    console.error("Error fetching study:", error);
    return null;
  }
};


// Create new study
export const createStudy = async (studyData) => {
  try {
    return await fetchAPI("biobank/studies", "POST", {}, studyData);
  } catch (error) {
    console.error("Error creating study:", error);
    throw error;
  }
};


// Update study (partial update using PATCH)
export const updateStudy = async (studyId, studyData) => {
  try {
    return await fetchAPI(
      `biobank/studies/${encodeURIComponent(studyId)}`,
      "PUT",
      {},
      studyData
    );
  } catch (error) {
    console.error("Error updating study:", error);
    throw error;
  }
};


// Delete study
export const deleteStudy = async (studyId) => {
  try {
    return await fetchAPI(`biobank/studies/${studyId}`, "DELETE");
  } catch (error) {
    console.error("Error deleting study:", error);
    throw error;
  }
};


// Fetch IRB study filters
export const fetchIRBStudyFilters = async () => {
  try {
    return await fetchAPI("admin/patients/studies", "GET");
  } catch (error) {
    console.error("Error fetching IRB study filters:", error);
    return [];
  }
};